import React from 'react';
import AiArticleIcon from '../../assets/icons/ai-article.svg';
import ChevronRightIcon from '../../assets/icons/summary-chevron-right.svg';
import './ai-summary-bar.css';

interface IAiSummaryBarProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  // Panel content, rendered under the bar while it is open.
  children?: React.ReactNode;
  className?: string;
}

// Collapsible gradient bar that expands into an AI-generated summary panel.
const AiSummaryBar: React.FC<IAiSummaryBarProps> = ({ title, isOpen, onToggle, children, className }) => (
  <div className={className}>
    <div
      className='ai-summary-bar'
      role='button'
      tabIndex={0}
      aria-expanded={isOpen}
      onClick={onToggle}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onToggle();
        }
      }}
    >
      <span className='ai-summary-title'>
        <span className='ai-summary-title-text'>{title}</span>
        <span className='ai-summary-icon'>
          <img src={AiArticleIcon} alt='' />
        </span>
      </span>
      <img
        src={ChevronRightIcon}
        alt=''
        className={isOpen ? 'ai-summary-chevron ai-summary-chevron-open' : 'ai-summary-chevron'}
      />
    </div>
    {isOpen && <div className='ai-summary-panel'>{children}</div>}
  </div>
);

export default AiSummaryBar;
